export default {"src":"/_next/static/media/premierBet.929685ea.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};